"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSizeme = require("react-sizeme");

var _commonReact = require("@devsta/common-react");

var _reactApollo = require("react-apollo");

var _api = require("../../../api");

var _api2 = require("../../../../../../../common/api");

var _UsersList = _interopRequireDefault(require("../components/UsersList"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function UsersList(_ref) {
  var history = _ref.history,
      teams = _ref.teams,
      displayLimit = _ref.displayLimit,
      organisationRoles = _ref.organisationRoles;

  var getFilteredTeams = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(inputVal) {
      var filtered;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              filtered = teams.filter(function (_ref3) {
                var name = _ref3.name;
                return name.toLowerCase().includes(inputVal.toLowerCase());
              }).map(function (_ref4) {
                var name = _ref4.name,
                    teamId = _ref4.teamId;
                return {
                  label: name.toUpperCase(),
                  value: teamId
                };
              }).slice(0, displayLimit);
              return _context.abrupt("return", new Promise(function (resolve) {
                resolve(filtered);
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getFilteredTeams(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return _react.default.createElement(_commonReact.AuthorisationConsumer, {
    requiresOrganisation: true
  }, function (_ref5) {
    var _ref5$selectedOrganis = _ref5.selectedOrganisation,
        organisationId = _ref5$selectedOrganis.organisationId,
        permissions = _ref5$selectedOrganis.permissions,
        ssoConfig = _ref5$selectedOrganis.ssoConfig;
    return _react.default.createElement(_commonReact.RequestProvider, {
      requests: {
        updateOrgMembership: (0, _api2.updateOrgMembership)(),
        searchOrgMemberships: (0, _api2.searchOrgMembershipsApi)(organisationId),
        resendUserOrgInvite: (0, _api.resendUserOrgInviteApi)(organisationId),
        forgotPassword: (0, _api2.forgotPassword)(),
        ghostStart: (0, _api2.ghostStartApi)()
      }
    }, function (requests) {
      return _react.default.createElement(_reactApollo.ApolloConsumer, null, function (apolloClient) {
        return _react.default.createElement(_reactSizeme.SizeMe, null, function (_ref6) {
          var size = _ref6.size;
          return _react.default.createElement(_UsersList.default, _extends({}, requests, {
            containerSize: size,
            organisationRoles: organisationRoles,
            teams: teams,
            loadOptions: getFilteredTeams,
            displayLimit: displayLimit,
            history: history,
            apolloClient: apolloClient,
            orgPermissions: permissions,
            ssoConfig: ssoConfig,
            organisationId: organisationId
          }));
        });
      });
    });
  });
}

var _default = (0, _react.memo)(UsersList);

exports.default = _default;